export default function LoadingNotificationPreferences() {
  return (
    <div className='container mx-auto'>
      <div className='w-full mx-auto mt-8'>
        <div className='animate-pulse flex flex-col my-4'>
          <div className='divide-y-2 py-1'>
            {Array.from(Array(10).keys()).map((num: number) => (
              <div key={num} className='space-y-2'>
                <div className='h-50 bg-neutralColor-light grid grid-cols-2 rounded p-5'>
                  <div>
                    <div className='h-4 w-1/4 bg-neutralColor-lightest rounded'></div>
                  </div>
                  <div className='space-y-4'>
                    <div className='w-full grid grid-cols-10 gap-4'>
                      <div className='w-full col-span-4 space-y-2'>
                        <div className='h-4 bg-neutralColor-lightest rounded'></div>
                        <div className='h-2 w-1/2 bg-neutralColor-lightest rounded'></div>
                      </div>
                      <div className='h-4 col-span-4'></div>
                      <div className='h-4 bg-neutralColor-lightest rounded'></div>
                      <div className='h-4 bg-neutralColor-lightest rounded'></div>
                    </div>
                    <div className='w-full grid grid-cols-10 gap-4'>
                      <div className='w-full col-span-4 space-y-2'>
                        <div className='h-4 bg-neutralColor-lightest rounded'></div>
                        <div className='h-2 w-1/2 bg-neutralColor-lightest rounded'></div>
                      </div>
                      <div className='h-4 col-span-4'></div>
                      <div className='h-4 bg-neutralColor-lightest rounded'></div>
                      <div className='h-4 bg-neutralColor-lightest rounded'></div>
                    </div>
                    <div className='w-full grid grid-cols-10 gap-4'>
                      <div className='w-full col-span-4 space-y-2'>
                        <div className='h-4 bg-neutralColor-lightest rounded'></div>
                        <div className='h-2 w-1/2 bg-neutralColor-lightest rounded'></div>
                      </div>
                      <div className='h-4 col-span-4'></div>
                      <div className='h-4 bg-neutralColor-lightest rounded'></div>
                      <div className='h-4 bg-neutralColor-lightest rounded'></div>
                    </div>
                    <div className='w-full grid grid-cols-10 gap-4'>
                      <div className='w-full col-span-4 space-y-2'>
                        <div className='h-4 bg-neutralColor-lightest rounded'></div>
                        <div className='h-2 w-1/2 bg-neutralColor-lightest rounded'></div>
                      </div>
                      <div className='h-4 col-span-4'></div>
                      <div className='h-4 bg-neutralColor-lightest rounded'></div>
                      <div className='h-4 bg-neutralColor-lightest rounded'></div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
